module.exports = __webpack_public_path__ + "static/DarksideDetective4-e538586abd9811dec5ea0d2ec5f62aec.png";